export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11569.6de2326b.jpg";